/**
 * 微信环境检测和JSSDK工具类
 */

/**
 * 检测是否在微信环境中
 * @returns {boolean}
 */
export function isWechatEnvironment() {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes('micromessenger');
}

/**
 * 检测是否在小程序环境中
 * @returns {boolean}
 */
export function isMiniProgramEnvironment() {
  const ua = navigator.userAgent.toLowerCase();
  return window.__wxjs_environment === 'miniprogram' || ua.includes('miniprogram');
}

/**
 * 获取环境信息
 * @returns {Object}
 */
export function getEnvironmentInfo() {
  const ua = navigator.userAgent.toLowerCase();
  return {
    isWechat: isWechatEnvironment(),
    isMiniProgram: isMiniProgramEnvironment(),
    userAgent: ua,
    wxjsEnvironment: window.__wxjs_environment
  };
}

/**
 * 配置微信JSSDK
 * @param {Object} config - JSSDK配置
 * @returns {Promise}
 */
export function configWechatSDK(config) {
  return new Promise((resolve, reject) => {
    if (!window.wx) {
      reject(new Error('微信JSSDK未加载'));
      return;
    }

    window.wx.config({
      debug: false,
      appId: config.appId,
      timestamp: config.timestamp,
      nonceStr: config.nonceStr,
      signature: config.signature,
      jsApiList: ['navigateToMiniProgram']
    });

    window.wx.ready(() => {
      console.log('微信JSSDK配置成功');
      resolve(window.wx);
    });

    window.wx.error((err) => {
      console.error('微信JSSDK配置失败:', err);
      reject(err);
    });
  });
}

/**
 * 跳转到小程序
 * @param {Object} options - 跳转参数
 * @returns {Promise}
 */
export function navigateToMiniProgram(options) {
  return new Promise((resolve, reject) => {
    if (!window.wx) {
      reject(new Error('微信JSSDK未初始化'));
      return;
    }

    // 检查是否在小程序环境中
    if (isMiniProgramEnvironment()) {
      // 在小程序环境中使用小程序API
      if (window.wx.miniProgram) {
        window.wx.miniProgram.navigateTo({
          url: options.path,
          success: resolve,
          fail: reject
        });
      } else {
        reject(new Error('小程序环境但wx.miniProgram不可用'));
      }
    } else {
      // 在微信浏览器中使用JSSDK
      window.wx.navigateToMiniProgram({
        targetAppId: options.appId,
        path: options.path,
        extraData: options.extraData,
        envVersion: options.envVersion || 'release',
        success: resolve,
        fail: reject
      });
    }
  });
}